import { Box } from "@mui/material";
import { Outlet } from "react-router";

export default function FullLayout() {

    return (
        <Box>
            <Outlet />
        </Box>
    );
}